import axios, { AxiosError } from 'axios';
import qs, { IStringifyOptions } from 'qs';

export function toQueryString(obj: Record<string, any>, options?: IStringifyOptions) {
  return qs.stringify(obj, {
    addQueryPrefix: true,
    skipNulls: true,
    indices: false,
    ...options,
  });
}

export function isRequestError<T = any>(error: unknown): error is AxiosError<T> {
  if (!error) return false;

  return axios.isAxiosError(error);
}
